import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Check } from '../../icons';
import { StyledIcon, StyledInput, StyledLabel } from './CheckBox.styles';
import { ICheckBoxProps } from './CheckBox.types';

const CheckBox = ({
  id,
  checked,
  disabled,
  name,
  label,
  user,
  value,
  onChange,
}: ICheckBoxProps): JSX.Element => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <StyledInput
        id={id}
        checked={checked}
        disabled={disabled}
        name={name}
        type="checkbox"
        user={user}
        value={value}
        onChange={onChange}
      />
      <StyledLabel htmlFor={id}>
        <StyledIcon>
          <Check color={user && theme.colors[user].main} />
        </StyledIcon>
        {label}
      </StyledLabel>
    </>
  );
};

export default CheckBox;
